import Loader from "react-loader-spinner";
import { PencilSquare, PlusSquare, Trash, ExclamationTriangle, DashCircle } from 'react-bootstrap-icons';
import { Table, Modal, Button, Row, Col, Alert } from 'react-bootstrap';
import { getComplaintStatusList, addEditComplaintsStatus, deleteComplaintsStatus } from "../store/api/ComplaintsAPI";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTachometerAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
const ModalAddEditComplaintStatus = (props) => {
    const { popData, setPopData } = props;
    const { show } = popData;
    const notForSelect = useRef(false);
    const [currentStatus, setCurrentStatus] = useState({ ID: 0, IsActive: true });
    const [error, setError] = useState(null);
    const [statusList, setStatusList] = useState(null);

    const close = () => {
        setPopData({
            show: false
        })
        setCurrentStatus(null);
    }
    const addOrUpdateStatus = () => {
        const onSuccess = (res) => {
            if (res.Error) {
                setError(res.Error);
                return;
            }
            getComplaintStatusList(setStatusList);
            setCurrentStatus({ ID: 0, IsActive: true });
        }
        if (
            !currentStatus.Status ||
            currentStatus.Status === '') {
            return;
        }

        addEditComplaintsStatus(currentStatus, onSuccess);
    }
    const deleteStatus = (id) => {
        notForSelect.current = true;
        const onDelete = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else {
                getComplaintStatusList(setStatusList);
            }
        }
        deleteComplaintsStatus(id, onDelete);
    }
    function cancelStatus() {
        setCurrentStatus({ ID: 0, IsActive: true });
    }
    function rowClick(row)
    {
        if(notForSelect.current)
        {
            notForSelect.current = false;
            return;
        }
        setCurrentStatus(row);
    }
    useEffect(() => {
        if (show)
            getComplaintStatusList(setStatusList);
    }, [show]);
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span> <FontAwesomeIcon icon={faTachometerAlt} size="lg" style={{ marginLeft: "3px" }} /> مدیریت وضعیت شکایات </span><FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {error && <Alert variant="danger"><ExclamationTriangle size={18} />&nbsp; {error} <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setError(null)} /></Alert>}
                <Table responsive className="fixedTable mt-2" id="tblstatuss" style={{ whiteSpace: "nowrap" }}>
                    <thead>
                        <tr>
                            <th style={{ width: "20%" }}>ترتیب نمایش</th>
                            <th style={{ width: "45%" }}>شرح وضعیت</th>
                            <th style={{ width: "20%" }}>فعال</th>
                            <th style={{ width: "15%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(statusList === "PENDING") &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center", width: "100%" }}>
                                    <Loader type="BallTriangle" color="rgb(228, 3, 117)" height={20} width={20} />
                                </td>
                            </tr>
                        }
                        {Array.isArray(statusList?.Data ?? "") &&
                            statusList.Data.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => rowClick(item)}>
                                    <td style={{ width: "20%" }}>{item.ItemOrder}</td>
                                    <td style={{ width: "45%" }}>{item.Status}</td>
                                    <td style={{ width: "20%" }}><input type="checkbox" readOnly className="form-check-input" checked={item.IsActive} /></td>
                                    <td style={{ width: "15%" }}>
                                        <Trash className="rowBtn" color="red" size={16} onClick={() => deleteStatus(item.ID)} />
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                {currentStatus &&
                    <Row>
                        <Col md={3} style={{ padding: "3px", paddingRight: "10px" }}>
                            <input type="text" className="tableRowInput" value={currentStatus?.ItemOrder ?? ""} onChange={e => setCurrentStatus({... currentStatus, ItemOrder: e.target.value})} />
                        </Col>
                        <Col md={6} style={{ padding: "3px" }}>
                            <input type="text" className="tableRowInput" value={currentStatus?.Status ?? ""}
                                onChange={e => setCurrentStatus({...currentStatus, Status: e.target.value})} />
                        </Col>
                        <Col md={3} style={{ padding: "2px" }}>
                            <Button variant="info" className="group-Btn-smalll" onClick={addOrUpdateStatus}>
                                {Number(currentStatus.ID) > 0 && <PencilSquare size={18} />}
                                {Number(currentStatus.ID) === 0 && <PlusSquare size={18} />}
                            </Button>
                            <Button className="group-Btn-smalll" variant="danger"><DashCircle size={18} onClick={cancelStatus}/></Button>
                        </Col>
                    </Row>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalAddEditComplaintStatus;